import { useMemo } from 'react';
import { isDefined, isUndefined } from 'utils/tsHelpers';
import { useConditionStateContext } from '../../../contexts';

export const useIsMultiValueCondition = () => {
  const { value, values } = useConditionStateContext();
  // Return true indicating the condition is multiValue if values is defined and value is undefined
  return useMemo(() => isDefined(values) && isUndefined(value), [values, value]);
};
